import { render, staticRenderFns } from "./huizongFooter.vue?vue&type=template&id=7524b3fa"
import script from "./huizongFooter.vue?vue&type=script&lang=js"
export * from "./huizongFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports